import { lazy, Suspense } from 'react'
import Loading from './components/Loading'
import BoxDetailSkeleton from './routes/BoxDetail/PageSkeleton'
const RushBPage = lazy(() => import('./routes/pages/index'))
const RushProvablyFair = lazy(() => import('./routes/ProvablyFair'))
const Odds = lazy(() => import('./routes/ProvablyFair/boxVersionSkinsInfo'))
const RushBBoxDetail = lazy(() => import('./routes/pages/BoxDetail/index'))

const RushRouter = {
  path: '/:lang',
  element: (
    <Suspense fallback={<Loading />}>
      <RushBPage />
    </Suspense>
  ),
}

const RushProvablyFairRouter = {
  path: 'provably-fair',
  element: (
    <Suspense fallback={<Loading />}>
      <RushProvablyFair />
    </Suspense>
  ),
  children: [
    {
      path: ':instanceId',
      element: (
        <Suspense fallback={<Loading />}>
          <RushProvablyFair />
        </Suspense>
      ),
    },
  ],
}

const OddsRouter = {
  path: 'odds/:instanceId',
  element: (
    <Suspense fallback={<Loading />}>
      <Odds />
    </Suspense>
  ),
}

const RushBBoxDetailRouter = {
  path: 'pbox/detail/:pBoxId',
  element: (
    <Suspense fallback={<BoxDetailSkeleton />}>
      <RushBBoxDetail />
    </Suspense>
  ),
}

const RushRouters = [RushRouter, RushProvablyFairRouter, OddsRouter, RushBBoxDetailRouter]
export default RushRouters
